import APITemplate from '@api/APITemplate'
import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { docs } from '@modules/documents/constants/URL'

class APIDocumentsSigners extends APITemplate {
  async carregar(forceUpdate = false) {
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['documents/signersLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['documents/signers']
      }
    }

    if (store.getters['documents/signersLoading']) {
      return store.getters['documents/signers']
    }

    store.dispatch('documents/setSignersLoading', true)

    const r = await con.get(docs.signer)
    // const r = mocks

    if (r && r.status === 200) {
      store.dispatch('documents/setSigners', r.value || [])
    } else {
      store.dispatch('documents/setSigners', [])
    }

    store.dispatch('documents/setSignersLoading', false)

    return r || {}
  }

  async salvar({
    id,
    email,
    id_profissional,
    id_agente_externo,
    id_app_clientes,
    cpf,
  }) {
    const dado = {
      email,
      id_profissional,
      id_agente_externo,
      cpf,
    }

    if (id_app_clientes) {
      dado.id_cliente = id_app_clientes
      dado.id_app_clientes = id_app_clientes
    }

    const data = {
      data: JSON.stringify(dado),
    }

    let r
    if (id) {
      r = await con.put(docs.signer, data)
    } else {
      r = await con.post(docs.signer, data)
    }
    // r = mocks

    if (r && r.status === 200) {
      store.dispatch('documents/addSigners', r.value[0] || r.value || {})
    }

    return r || {}
  }

  async saveBulk({ id, dado }) {
    const data = {
      data: JSON.stringify(dado),
    }

    let r = await con.post(docs.signerBulk(id), data)

    // r = mocks

    if (r && r.status === 200) {
      this.carregar(true)
    }

    return r || {}
  }
}

const apiDocumentsSigners = new APIDocumentsSigners()
export { apiDocumentsSigners }
